import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import { SoftwareManagementCardFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import MoneyWithCurrency from 'modules/core/lib/money'

import { CardStatusTag } from 'modules/banking/components/CardStatusTag'
import { cardLimitPeriodText } from 'modules/banking/lib/cards/cardLimitPeriodText'
import { last4digits } from 'modules/banking/lib/cards/last4digits'

interface Props {
  card: SoftwareManagementCardFragment
  currency: string
  onClick: () => void
}

const CardWidget = ({ card, currency, onClick }: Props) => {
  const remainingAmountText = cardLimitPeriodText(card)
  const amountLeft = card.cardLimit?.remainingForCurrentPeriod || 0
  const {
    access: { locale },
  } = useCurrentSession()

  return (
    <Box
      gap="s48"
      padding="s24"
      width="full"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{ all: 'abs006' }}
      aria-label="card-widget"
    >
      <Box width="full" flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Box gap="s16" flexDirection="row" alignItems="center" justifyContent="spaceBetween">
          <Box
            width="s96"
            height="s64"
            paddingY="s8"
            paddingX="s12"
            flexDirection="columnReverse"
            alignItems="flexEnd"
            boxShadow="s400"
            background="radicalRed1000"
            borderRadius={{ all: 'abs008' }}
          >
            <Box width="s24" flexDirection="rowReverse">
              <Icon.Large icon="logo-avatar" color="grey000White" />
            </Box>
          </Box>

          <Box>
            <Text.Normal weight="semibold" color="grey1000">
              {card.alias}
            </Text.Normal>

            <Text.Normal>{last4digits(card)}</Text.Normal>
          </Box>
        </Box>

        <Button type="secondary" onClick={onClick} iconName="arrow-right" />
      </Box>
      <Box width="full" flexDirection="row" alignItems="center" justifyContent="spaceBetween">
        <Box gap="s6" flexDirection="row" alignItems="center">
          <Text.Normal weight="medium" color="grey1000">
            {MoneyWithCurrency({
              amount: amountLeft,
              currency,
              locale,
            })}
          </Text.Normal>

          <Text.Normal>{remainingAmountText}</Text.Normal>
        </Box>

        <Box>
          <CardStatusTag card={card} />
        </Box>
      </Box>
    </Box>
  )
}

export default CardWidget
